import { createSlice } from "@reduxjs/toolkit";

export const adminSlice = createSlice({
  name: "admin",
  initialState: {
    isLoading: false,
    hasError: true,
    messageError: "",
    adminUsers: [],
    profiles: [],
    clients: [],
    appUsers: [],
    services: [],
    drivers: [],
    valueDate: "0",
    valueModuleStatus: "RECONOCIMIENTO ADUANERO CONCLUIDO",
  },
  reducers: {
    loadProfiles: (state, action) => {
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.messageError = action.payload.message;
        state.isLoading = false;
        return;
      }
      state.hasError = false;

      state.profiles = action.payload.data;
    },
    loadUsers: (state, action) => {
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.messageError = action.payload.message;
        state.isLoading = false;
        return;
      }
      state.hasError = false;
      state.adminUsers = action.payload.data;
    },
    loadClients: (state, action) => {
      //TODO: Refactory this
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.messageError = action.payload.message;
        state.isLoading = false;
        return;
      }
      state.hasError = false;
      state.clients = action.payload.data;
    },
    loadUsersApp: (state, action) => {
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.messageError = action.payload.message;
        state.isLoading = false;
        return;
      }
      state.hasError = false;
      state.appUsers = action.payload.data;
    },
    loadServices: (state, action) => {
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.messageError = action.payload.message;
        state.isLoading = false;
        return;
      }
      state.hasError = false;
      state.services = action.payload.data;
      state.isLoading = false;
    },
    loadDrivers: (state, action) => {
      if (action.payload.status !== 200) {
        state.hasError = true;
        state.isLoading = false;
        state.messageError = action.payload.message;
        return;
      }
      state.hasError = false;
      state.drivers = action.payload.data;
      state.isLoading = false;
    },
    setLoading: (state) => {
      state.isLoading = true;
    },
    setError: (state, action) => {
      state.hasError = true;
      state.messageError = action.payload.message;
    },
    setValueDate: (state, action) => {
      state.valueDate = action.payload;
    },
    setValueModuleStatus: (state, action) => {
      state.valueModuleStatus = action.payload;
    },
  },
});

export const {
  loadClients,
  loadDrivers,
  loadProfiles,
  loadServices,
  loadUsers,
  loadUsersApp,
  setLoading,
  setError,
  setValueDate,
  setValueModuleStatus,
} = adminSlice.actions;
